import ReactDOM from 'react-dom';
import preloaded from '../../src/preloaded';
import TagEditorContainer from '../../src/tags/TagEditorContainer.js';

let url = '';
if (preloaded.picture) {
  url = preloaded.picture._links.tags.href;
} else {
  url = preloaded.video._links.tags.href;
}

ReactDOM.render(
  <TagEditorContainer
    source={url}
  />,
  document.getElementById("MediaTagArea")
);